<template>
  <section class="clients-section">
    <div class="section-container">

      <!-- 标题区域 -->
      <div class="header">
        <div class="tag">• CLIENT FEEDBACK</div>
        <h2 class="title">What Our <span class="gradient">Clients Say</span></h2>

        <!-- 居中分割线 -->
        <div class="divider-container">
          <div class="line"></div>
          <span class="square-icon">[■]</span>
          <div class="line"></div>
        </div>
      </div>

      <!-- 评论网格 -->
      <div class="grid">
        <div v-for="(client, index) in clients" :key="index" class="card">
          <!-- 左上角水印编号 -->
          <div class="card-num">{{ client.num }}</div>

          <!-- 星级 -->
          <div class="stars">★★★★★</div>

          <!-- 正文 -->
          <p class="content">{{ client.text }}</p>

          <!-- 底部信息 -->
          <div class="footer">
            <div class="user-info">
              <span class="flag">{{ client.flag }}</span>
              <div class="user-text">
                <div class="name">{{ client.name }}</div>
                <div class="location">{{ client.location }}</div>
              </div>
            </div>

            <div class="verified">
              <span class="check-icon">✓</span> VERIFIED
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'ClientsSaySection',
  data() {
    return {
      clients: [
        {
          num: '01',
          flag: '🇺🇸',
          name: 'James Harrington',
          location: 'UNITED STATES',
          text: 'I lost over $45,000 to a fake crypto investment platform. Fraud Counsel traced every transaction and helped me file an enforcement case. Their process was thorough and professional from start to finish. I genuinely cannot thank them enough for restoring my confidence.'
        },
        {
          num: '02',
          flag: '🇸🇬',
          name: 'David Tan Wei',
          location: 'SINGAPORE',
          text: 'Their blockchain intelligence tools tracked my stolen USDT across four different wallets and two exchanges. The team coordinated directly with the platforms and recovery was completed within the week. Truly world-class forensic capability and outstanding service.'
        },
        {
          num: '03',
          flag: '🇳🇬',
          name: 'Emeka Chukwu',
          location: 'NIGERIA',
          text: 'After a Ponzi scheme took three years of savings, Fraud Counsel delivered results that local authorities simply could not. Their cross-border capability is unmatched and the team is truly dedicated to every client. I am incredibly grateful for their extraordinary help.'
        }
      ]
    };
  }
}
</script>

<style scoped>
.clients-section {
  background-color: #070b14;
  /* 深色背景 */
  padding: 60px 5%;
  color: #e2e8f0;
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
}

/* 标题区域 */
.header {
  position: relative;
  margin-bottom: 50px;
}

.tag {
  color: #4fd1c5;
  /* 淡青色 */
  font-size: 0.75rem;
  letter-spacing: 2px;
  margin-bottom: 10px;
  font-weight: 500;
}

.title {
  font-size: 2.6rem;
  /* 字体缩小 */
  font-weight: 700;
  margin: 0 0 20px;
}

.gradient {
  background: linear-gradient(90deg, #4fd1c5, #8be9fd);
  /* 淡青-淡蓝渐变 */
  -webkit-background-clip: text;
  color: transparent;
}

.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(79, 209, 197, 0.2);
}

.divider-container .square-icon {
  color: #4fd1c5;
  font-size: 0.8rem;
  font-family: monospace;
  margin: 0 15px;
}

/* 卡片网格 */
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
}

/* 卡片样式 */
.card {
  position: relative;
  background: #0d1117;
  border: 1px solid #253045;
  /* 淡边框 */
  border-radius: 8px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}

.card:hover {
  border-color: #4fd1c5;
  transform: translateY(-5px);
}

/* 水印编号 */
.card-num {
  position: absolute;
  top: 15px;
  left: 20px;
  color: rgba(255, 255, 255, 0.05);
  /* 极淡的白色 */
  font-family: monospace;
  font-size: 3.5rem;
  font-weight: 800;
  pointer-events: none;
}

.stars {
  color: #fbbf24;
  /* 淡黄色 */
  font-size: 1.1rem;
  margin-bottom: 20px;
  letter-spacing: 2px;
}

.content {
  color: #a0b3cc;
  font-size: 0.9rem;
  /* 字体缩小 */
  line-height: 1.8;
  margin-bottom: 30px;
  flex: 1;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(37, 48, 69, 0.6);
  /* 极淡的线条 */
  padding-top: 20px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.flag {
  font-size: 1.5rem;
}

.user-text {
  text-align: left;
}

.name {
  font-size: 1.1rem;
  /* 字体缩小 */
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}

.location {
  color: #a0b3cc;
  font-size: 0.75rem;
  letter-spacing: 1px;
}

.verified {
  color: #4fd1c5;
  /* 淡青色 */
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 6px;
}

.check-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 12px;
  height: 12px;
  border: 1px solid #4fd1c5;
  border-radius: 50%;
  font-size: 0.6rem;
}

/* 响应式适配 */
@media (max-width: 1200px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .title {
    font-size: 2.2rem;
  }

  .grid {
    grid-template-columns: 1fr;
  }
}
</style>